const draggable = {
  inserted: function(el, binding) {
    el.style.cursor = "move";
    el.onmousedown = function(e) {
      const disx = e.pageX - el.offsetLeft;
      const disy = e.pageY - el.offsetTop;
      document.onmousemove = function(e) {
        let x = e.pageX - disx;
        let y = e.pageY - disy;
        const maxX =
          el.parentElement.clientWidth -
          parseInt(window.getComputedStyle(el).width);
        const maxY =
          el.parentElement.clientHeight -
          parseInt(window.getComputedStyle(el).height);
        if (x < 0) {
          x = 0;
        } else if (x > maxX) {
          x = maxX;
        }
        if (y < 0) {
          y = 0;
        } else if (y > maxY) {
          y = maxY;
        }
        el.style.left = x + "px";
        el.style.top = y + "px";
        // 有回调函数则带上，没有则不执行
        binding.value && binding.value({ x, y });
      };
      document.onmouseup = function() {
        document.onmousemove = document.onmouseup = null;
      };
    };
  },
};
export default draggable;
